import { render, staticRenderFns } from "./MtipotransporteFormHeader.vue?vue&type=template&id=3c561bc3"
import script from "./MtipotransporteFormHeader.vue?vue&type=script&lang=js"
export * from "./MtipotransporteFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports